import {
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
  } from '@angular/core';
  import { DatePipe } from '@angular/common';
  import { FormsModule } from '@angular/forms';
  import { Router } from '@angular/router';

  import { AccreditationService } from '../../services/accreditation.service';
  import { AuthService } from '../../services/auth.service';
  import { FolioPillComponent } from '../ui/folio-pill/folio-pill.component';
  
  @Component({
    selector: 'app-accreditation-list',
    standalone: true,
    imports: [DatePipe, FormsModule, FolioPillComponent],
    templateUrl: './accreditation-list.html',
    styleUrl: './accreditation-list.scss',
  })
  export class AccreditationListComponent {
    private accreditationService = inject(
      AccreditationService,
    );
  
    private cdr = inject(ChangeDetectorRef);
    private router = inject(Router);
    private authService = inject(AuthService);
  
    private destroyRef = inject(DestroyRef);
  
    accreditations: any[] = [];
    showHistory = false;

    // BÚSQUEDA POR FOLIO DE INTERACCIÓN (Fase C2.1)
    folioSearch = '';

    private matchesFolio(accreditation: any): boolean {
      const term = this.folioSearch.trim().toLowerCase();
      if (!term) {
        return true;
      }
      const folio = (accreditation?.interactionFolio || '').toString().toLowerCase();
      return folio.includes(term);
    }

    onFolioSearchChange(): void {
      this.accreditationsPage = 1;
    }

    // PAGINACIÓN DE ACREDITACIONES
    accreditationsPage = 1;
    accreditationsPageSize = 5;
    get currentAccreditations(): any[] {
        const source = this.showHistory
          ? this.historyAccreditations
          : this.pendingAccreditations;
      
        const start =
          (this.accreditationsPage - 1) *
          this.accreditationsPageSize;
      
        const end =
          start + this.accreditationsPageSize;
      
        return source.slice(start, end);
      }

      get accreditationsTotalPages(): number {
        const total = this.showHistory
          ? this.historyAccreditations.length
          : this.pendingAccreditations.length;
      
        return Math.max(
          Math.ceil(total / this.accreditationsPageSize),
          1,
        );
      }
      
      get accreditationsPages(): number[] {
        return Array.from(
          { length: this.accreditationsTotalPages },
          (_, index) => index + 1,
        );
      }

      toggleAccreditationsView(history: boolean): void {
        this.showHistory = history;
        this.accreditationsPage = 1;
      }

      goToAccreditationsPage(page: number): void {
        if (
          page < 1 ||
          page > this.accreditationsTotalPages
        ) {
          return;
        }
      
        const scrollPosition = window.scrollY;
      
        this.accreditationsPage = page;
        this.cdr.detectChanges();
      
        requestAnimationFrame(() => {
          window.scrollTo({
            top: scrollPosition,
            behavior: 'auto',
          });
        });
      }
      
      previousAccreditationsPage(): void {
        this.goToAccreditationsPage(
          this.accreditationsPage - 1,
        );
      }
      
      nextAccreditationsPage(): void {
        this.goToAccreditationsPage(
          this.accreditationsPage + 1,
        );
      }

    get pendingAccreditations(): any[] {
    return this.accreditations.filter(
        (accreditation) =>
        accreditation.status === 'pending' &&
        this.matchesFolio(accreditation)
    );
    }

    get historyAccreditations(): any[] {
    return this.accreditations.filter(
        (accreditation) =>
        (accreditation.status === 'approved' ||
        accreditation.status === 'rejected') &&
        this.matchesFolio(accreditation)
    );
    }

    isLoading = true;
    successMessage = '';

    processingId: string | null = null;
    expandedAccreditationId: string | null = null;

    showManualHoursModal = false;

    selectedAccreditation: any | null = null;

    manualHours: number | null = null;
  
    ngOnInit(): void {
      const user = this.authService.getCurrentUser();
      if (user?.role === 'student') {
        this.router.navigate(['/my-accreditations']);
        return;
      }
      this.loadAccreditations();
    }
  
    loadAccreditations(): void {
      this.isLoading = true;
  
      this.accreditationService
        .getAllAccreditations()
        .subscribe({
          next: (response: any) => {
            console.log(
              '🟢 ACREDITACIONES CARGADAS:',
              response,
            );
  
            this.accreditations =
              response.data.documents;
  
            this.isLoading = false;
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR CARGANDO ACREDITACIONES:',
              error,
            );
  
            this.accreditations = [];
  
            this.isLoading = false;
  
            this.cdr.detectChanges();
          },
        });
    }

    approveAccreditation(accreditation: any): void {
        this.processingId = accreditation._id;
      
        this.accreditationService
          .approveAccreditation(accreditation._id)
          .subscribe({
            next: () => {
              this.processingId = null;
              this.loadAccreditations();
            },
            error: (error) => {
              console.error(
                '🔴 ERROR APROBANDO ACREDITACIÓN:',
                error,
              );
      
              this.processingId = null;
              this.cdr.detectChanges();
            },
          });
    }

    rejectAccreditation(accreditation: any): void {
        this.processingId = accreditation._id;
      
        this.accreditationService
          .rejectAccreditation(accreditation._id)
          .subscribe({
            next: () => {
              this.processingId = null;
              this.loadAccreditations();
            },
            error: (error) => {
              console.error(
                '🔴 ERROR RECHAZANDO ACREDITACIÓN:',
                error,
              );
      
              this.processingId = null;
              this.cdr.detectChanges();
            },
          });
    }
    openManualHoursModal(accreditation: any): void {
        this.selectedAccreditation = accreditation;
        this.manualHours = null;
        this.showManualHoursModal = true;
      }

    closeManualHoursModal(): void {
        this.showManualHoursModal = false;
        this.selectedAccreditation = null;
        this.manualHours = null;
    }

    toggleAccreditationDetails(accreditation: any): void {
        if (this.expandedAccreditationId === accreditation._id) {
          this.expandedAccreditationId = null;
          return;
        }
      
        this.expandedAccreditationId = accreditation._id;
      }

    assignManualHours(): void {
        if (
          !this.selectedAccreditation ||
          this.manualHours === null ||
          this.manualHours <= 0
        ) {
          return;
        }
      
        this.processingId = this.selectedAccreditation._id;
      
        const hoursAssigned = this.manualHours;
        this.accreditationService
          .assignManualHours(
            this.selectedAccreditation._id,
            this.manualHours,
          )
          .subscribe({
            next: () => {
                this.processingId = null;
                this.closeManualHoursModal();
              
                this.successMessage =
                  `✓ Se asignaron ${hoursAssigned} horas correctamente.`;
              
                this.loadAccreditations();
              
                this.cdr.detectChanges();
              
                setTimeout(() => {
                  this.successMessage = '';
                  this.cdr.detectChanges();
                }, 4000);
              },
            error: (error: any) => {
              console.error(
                '🔴 ERROR ASIGNANDO HORAS MANUALMENTE:',
                error,
              );
      
              this.processingId = null;
              this.cdr.detectChanges();
            },
          });
      }
  }